/**
 * Customer package enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// A package a customer bought. Pending until the first payment succeeds;
// validity runs from activation.
export const clientPackageStatusLabels = {
    pending: 'Awaiting payment',
    active: 'Active',
    expired: 'Expired',
    cancelled: 'Cancelled',
};
export const clientPackageStatusValues = Object.keys(clientPackageStatusLabels);
// Where the package was sold.
export const clientPackageSourceLabels = {
    online: 'Online booking',
    staff: 'Staff',
    till: 'Till',
};
export const clientPackageSourceValues = Object.keys(clientPackageSourceLabels);
//# sourceMappingURL=packages.js.map